import { useSelector } from "react-redux";
import { PiInteractionDropdown } from "../../../components/PiInteractionDropdown";
import { ICharacterPartDefinition } from "../../../models/interactions/SetCharacterParts";
import { selectCachedCharacterPartDetailsByName } from "../../../app/slices/CharacterPartsSlice";
import { RootState } from "../../../app/Store";

export default function CharacterPartVariantDropdown(props: {
  definition: ICharacterPartDefinition;
  onVariantSelected: (variantId: string) => void;
}) {
  const { definition, onVariantSelected } = { ...props };
  const cachedPartDetails = useSelector((state: RootState) =>
    selectCachedCharacterPartDetailsByName(state, definition.partId)
  );

  const variants = cachedPartDetails?.variants || [];

  const variantItems = variants.map((v) => {
    return (
      <PiInteractionDropdown.Item key={v} onClick={() => onVariantSelected(v)}>
        <div className={"flex gap-4 justify-center w-full"}>
          <div className={"my-auto truncate"}>{v}</div>
        </div>
      </PiInteractionDropdown.Item>
    );
  });

  return (
    <PiInteractionDropdown variant="small">
      <PiInteractionDropdown.Trigger>
        <div className={"flex gap-x-4 w-full"}>{definition.variantId}</div>
      </PiInteractionDropdown.Trigger>
      {variantItems}
    </PiInteractionDropdown>
  );
}
